<template>
  <Navigator />
  <h1 class="title">
    申请价值分析报告
  </h1>
  <FormContainer />
</template>

<script>
import Navigator from './components/Navigator.vue'
import FormContainer from './components/FormContainer.vue'
export default {
  name: 'App',
  data() {
    return {
      plat: this.checkPlatform(),
    }
  },
  components: {
    'Navigator': Navigator,
    'FormContainer': FormContainer
  },
  mounted() {
    console.log(this.plat)
  }
}
</script>
<style>
#app {
  width: 100%;
  height: 100%;
}
.title {
  position: relative;
  background-color: #2665a0;
  text-indent: 30px;
  font-size: 24px;
  line-height: 36px;
  color: #fff;
  width: 960px;
  max-width: 80%;
  margin: 25px auto 10px auto;
}
.title:before {
  content: "";
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 0;
  height: 0;
  border: 18px solid transparent;
  border-left-color: #fff;
}
.title:after {
  content: "";
  display: block;
  position: absolute;
  right: -12px;
  top: 5px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 13px;
  border-color: #2665a0;
  transform: rotate(45deg);
}
</style>